import React from 'react';

type Heading2Props = {
    element?: keyof JSX.IntrinsicElements;
    children: React.ReactNode;
};
export function Heading2({element = 'h2', children}: Heading2Props) {
    return React.createElement(element, {className: 'font-heading leading-500 text-500'}, children);
}
